// removed by extract-text-webpack-plugin
module.exports = {"main":"RouteNameDisplay-main--3yIDR","routeIcon":"RouteNameDisplay-routeIcon--386ct","routeName":"RouteNameDisplay-routeName--3B8HB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RouteNameDisplay/RouteNameDisplay.scss
// module id = QAri
// module chunks = 4